import { render, staticRenderFns } from "./SalesVelocityCalculator.vue?vue&type=template&id=fa1ab104&scoped=true"
import script from "./SalesVelocityCalculator.vue?vue&type=script&lang=js"
export * from "./SalesVelocityCalculator.vue?vue&type=script&lang=js"
import style0 from "./SalesVelocityCalculator.vue?vue&type=style&index=0&id=fa1ab104&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa1ab104",
  null
  
)

export default component.exports